<template>
        <div>
	        <form @submit="formSubmit" enctype="multipart/form-data">
              
            <div class="row">
            <div class="col-md-12">
              <table>
			  <tr v-for="(challan,index)  in challans" :key="challan.id" style="line-height:40px;">
              <td style="vertical-align: middle;">Challan for {{employeename}} ({{employeeid}}) - {{challan.month}} {{challan.year}}</td> <td>  <a :href="$api_url+'/challandownload/'+challan.id"><span class="ml-2"><i class="far fa-file-pdf" aria-hidden="true" style="font-size:50px;color:red"></i></span></a></td>
              </tr>
              </table>
              </div>
            </div>
           </form>
        </div>	
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
</style>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
			 // console.log(this.componentdata);  
		  },
		  props: ['challanname', 'challan_month', 'challan_fiscal', 'employee_id', 'employee_name'],
				 
   
		  data() {
			  
			  return {
                challanmonth: this.challan_month,
                challanfiscal: this.challan_fiscal,
                challans: [],
                empdata: [],
                companies: [],
                accchallans:[],
                fiscal_years: [],
                fiscals: null,
                curr_fiscal: [],
                employeeid: this.employee_id,
                employeename: this.employee_name,
				  
			  }
		  },
		  
		  methods:{
			  setSearch: function(pageflg)
			  {
				
			  },
             getChallanInfo: function()
             {

                   axios.get(this.$api_url+'/employeechallanlist/'+this.challanmonth+'/'+this.challanfiscal, {
                            params: {
                            }
                    }).then(function(response){
                     
                    this.challans = response.data.data.challans;
                    this.empdata = response.data.data.employee_info;
                    this.companies = response.data.data.companies;
                    this.fiscal_years = response.data.data.fiscal_years;
                    this.curr_fiscal = response.data.data.fiscal_year;
                    this.fiscals = response.data.data.fiscal_year;

                    
                }.bind(this));
             }, 
             formSubmit(e) {

			  }
		  },
		  created: function(){
		     this.getChallanInfo();
		  }
	  }
  </script>